<script lang="ts">
  import { css, cx } from '@agapi/ui/panda/css';
  import { colorToken } from '@agapi/ui/panda/utils';
  import { loader } from './loader.styles';
  import { visuallyHidden } from '@agapi/ui/panda/patterns';
  import type { LoaderProps } from './loader.types';

  const { type = 'spinner', size = 'md', color, css: cssProp }: LoaderProps = $props();

  const classes = $derived(loader({ type, size }));
  const colorStyle = $derived(color ? colorToken(color) : '');
</script>

<div class={classes.wrapper} aria-live="polite" aria-busy="true">
  <span class={cx(classes.loader, css(cssProp))} style:color={colorStyle}></span>
  <span class={visuallyHidden()}>Loading...</span>
</div>
